<template>
  <div class="component-content sub-content">
    <div class="title">
      <h2 class="name">项目开工登记</h2>
      <a href="javascript:;" @click="$router.back()" class="back-btn"
        >返回项目详情</a
      >
    </div>
    <div class="form-content" v-if="project.name">
      <el-col :span="23">
        <el-form ref="form" :model="form" label-width="140px" class="form">
          <create-start
            ref="create"
            :project="project"
            :userData="userData"
            :formByFather="form"
          ></create-start>

          <div class="tip" style="margin: 20px 0 0 40px">* 相关附件</div>
          <div class="clear">
            <el-form-item label="上传附件">
              <attachments
                :projectId="form.projectId"
                :contractId="form.contractId"
                ref="attachments"
                :type="992"
                :arr="attachmentArr"
              >
              </attachments>
            </el-form-item>
          </div>

          <el-form-item label="">
            <div class="form-btn-room">
              <el-button
                :loading="formLoading"
                @click="startProject()"
                class="form-btn"
                type="success"
                >确认提交项目开工登记
              </el-button>
            </div>
          </el-form-item>
        </el-form>
      </el-col>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Attachments from "@/components/Attachments";
import CreateStart from "@/page/form/createStart";

import ObjectUtil from "../mixins/objectUtil";
export default {
  mixins: [ObjectUtil],
  components: {
    CreateStart,
    Attachments,
  },
  computed: {
    ...mapState({
      userData: (state) => state.main.userData,
    }),
  },
  data() {
    return {
      project: {},
      kgInfo: "",
      form: {
        projectId: "",
        kgqksm: "",
        kgsj: "",
      },
      formLoading: false,
    };
  },
  mounted() {
    this.form.projectId = this.$route.params.projectId;
    this.getProject();
    this.getKgInfo();
  },
  methods: {
    // 获取开工登记数据
    getKgInfo() {
      ajax.get("/gc/project/kg/info/" + this.form.projectId, "", (res) => {
        this.kgInfo = res.vo ? res.vo : "";
        if (this.kgInfo) {
          this.attachmentArr = this.kgInfo.attachments
            ? this.kgInfo.attachments
            : [];
          this.form.kgsj = this.kgInfo.kgsj;
          this.form.kgqksm = this.kgInfo.kgqksm;
        }
      });
    },
    // 获取项目
    getProject() {
      ajax.get("/gc/project/detail/" + this.form.projectId, "", (res) => {
        this.project = res.vo;

        // 修改当前选中的侧边栏
        this.setNavType(this.project);

        this.form.intro = this.project.intro;
      });
    },
    // 提交
    startProject() {
      if (!this.form.kgsj) {
        this.$message.error("请准确填写开工时间");
        return;
      }

      this.form.attachments = this.$refs.attachments.getAttachments();
      this.formLoading = true;
      ajax.post(
        "/gc/project/kg",
        this.form,
        (res) => {
          this.$message.success("提交项目开工登记成功");
          this.$router.push("/Project/Detail/" + this.form.projectId);
          this.formLoading = false;
        },
        (res) => {
          this.formLoading = false;
        }
      );
    },
  },
  watch: {},
};
</script>


// WEBPACK FOOTER //
// src/page/project/formLayout/createStart.vue